// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/family.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { ValueSource } from "./value_source";
import { Province } from "./address";
import { Property } from "./property";
import { Expense } from "./expense";
import { Person } from "./person";
import { Loan } from "./debts";
import { Mortgage } from "./debts";
import { Address } from "./address";
import { DateSchedule } from "../../optimizer/v1/date_schedule";
import { Date } from "./date";
/**
 * @generated from protobuf message core.v1.FinancialPriority
 */
export interface FinancialPriority {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: int32 level = 3;
     */
    level: number; // importance, 1-10; the engine weights completion by 2^level
    /**
     * @generated from protobuf field: core.v1.Date next_due_date = 4;
     */
    nextDueDate?: Date; // the goal date the user chose (not a schedule anchor)
    /**
     * @generated from protobuf field: optional double required_funding = 5;
     */
    requiredFunding?: number; // unset = unknown cost; the defaults pass estimates it
    /**
     * @generated from protobuf field: core.v1.Date end_date = 7;
     */
    endDate?: Date; // recurring only: until when
    /**
     * @generated from protobuf field: optional bool is_recurring = 8;
     */
    isRecurring?: boolean;
    /**
     * @generated from protobuf field: optimizer.v1.DateSchedule date_schedule = 9;
     */
    dateSchedule?: DateSchedule;
    /**
     * @generated from protobuf field: core.v1.PriorityKind kind = 10;
     */
    kind: PriorityKind;
    /**
     * @generated from protobuf field: optional double funded_this_period = 11;
     */
    fundedThisPeriod?: number; // received so far toward the current occurrence
    /**
     * @generated from protobuf field: repeated string beneficiary_uuids = 12;
     */
    beneficiaryUuids: string[]; // Dependent or Person uuids
}
/**
 * @generated from protobuf message core.v1.HomebuyingPriority
 */
export interface HomebuyingPriority {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: int32 level = 3;
     */
    level: number;
    /**
     * @generated from protobuf field: core.v1.Date due_date = 4;
     */
    dueDate?: Date;
    /**
     * @generated from protobuf field: double house_price = 5;
     */
    housePrice: number;
    /**
     * @generated from protobuf field: core.v1.Address address = 6;
     */
    address?: Address; // unset province = the household's (the defaults pass)
    /**
     * unset = 20% of the price, filled by the defaults pass; at least Canada's legal minimum (validation)
     *
     * @generated from protobuf field: optional double down_payment = 7;
     */
    downPayment?: number;
}
/**
 * @generated from protobuf message core.v1.Dependent
 */
export interface Dependent {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string given_name = 2;
     */
    givenName: string;
    /**
     * @generated from protobuf field: string family_name = 3;
     */
    familyName: string;
    /**
     * @generated from protobuf field: core.v1.Date dob = 4;
     */
    dob?: Date;
}
/**
 * @generated from protobuf message core.v1.Family
 */
export interface Family {
    /**
     * @generated from protobuf field: string uuid = 1;
     */
    uuid: string;
    /**
     * @generated from protobuf field: string family_name = 2;
     */
    familyName: string;
    /**
     * @generated from protobuf field: int32 education_priority_level = 3;
     */
    educationPriorityLevel: number;
    /**
     * @generated from protobuf field: int32 retirement_priority_level = 4;
     */
    retirementPriorityLevel: number; // "Retiring comfortably" (always on)
    /**
     * @generated from protobuf field: repeated core.v1.FinancialPriority financial_priorities = 6;
     */
    financialPriorities: FinancialPriority[];
    /**
     * @generated from protobuf field: repeated core.v1.Dependent dependents = 7;
     */
    dependents: Dependent[];
    /**
     * @generated from protobuf field: repeated core.v1.Mortgage mortgages = 8;
     */
    mortgages: Mortgage[];
    /**
     * @generated from protobuf field: repeated core.v1.Loan loans = 9;
     */
    loans: Loan[];
    /**
     * @generated from protobuf field: repeated core.v1.Person persons = 10;
     */
    persons: Person[]; // at least one
    /**
     * @generated from protobuf field: repeated core.v1.Expense expenses = 11;
     */
    expenses: Expense[];
    /**
     * @generated from protobuf field: repeated core.v1.HomebuyingPriority homebuying_priorities = 12;
     */
    homebuyingPriorities: HomebuyingPriority[];
    /**
     * @generated from protobuf field: repeated core.v1.Property properties = 13;
     */
    properties: Property[];
    /**
     * @generated from protobuf field: core.v1.Province province = 14;
     */
    province: Province; // where the household lives (tax jurisdiction)
    /**
     * @generated from protobuf field: core.v1.MaritalStatus marital_status = 15;
     */
    maritalStatus: MaritalStatus;
    /**
     * @generated from protobuf field: core.v1.RetirementMethod retirement_method = 16;
     */
    retirementMethod: RetirementMethod;
    /**
     * The date the stored facts describe. The engine simulates from here; days before the plan's start
     * date are the "since your last check-in" period (plan refresh).
     *
     * @generated from protobuf field: core.v1.Date facts_as_of = 17;
     */
    factsAsOf?: Date;
    /**
     * @generated from protobuf field: map<string, core.v1.ValueSource> field_sources = 18;
     */
    fieldSources: {
        [key: string]: ValueSource;
    };
}
// The household as stored: only facts a user can look up, each with its value source
// (architecture-redesign.md items D and J). Everything else is computed by the engine each run.
// Stored as one versioned proto3-JSON document per household; renaming or removing a field needs a
// schema upgrade in the backend (family document upgraders).

/**
 * @generated from protobuf enum core.v1.PriorityKind
 */
export enum PriorityKind {
    /**
     * @generated from protobuf enum value: PRIORITY_KIND_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PRIORITY_KIND_CHILD_EDUCATION = 1;
     */
    CHILD_EDUCATION = 1,
    /**
     * @generated from protobuf enum value: PRIORITY_KIND_BUY_HOME = 2;
     */
    BUY_HOME = 2,
    /**
     * @generated from protobuf enum value: PRIORITY_KIND_BIGGER_HOME = 3;
     */
    BIGGER_HOME = 3,
    /**
     * @generated from protobuf enum value: PRIORITY_KIND_RENOVATION = 4;
     */
    RENOVATION = 4,
    /**
     * @generated from protobuf enum value: PRIORITY_KIND_TRAVEL = 5;
     */
    TRAVEL = 5,
    /**
     * @generated from protobuf enum value: PRIORITY_KIND_WEDDING = 6;
     */
    WEDDING = 6,
    /**
     * @generated from protobuf enum value: PRIORITY_KIND_START_BUSINESS = 7;
     */
    START_BUSINESS = 7,
    /**
     * @generated from protobuf enum value: PRIORITY_KIND_NEW_CAR = 8;
     */
    NEW_CAR = 8,
    /**
     * @generated from protobuf enum value: PRIORITY_KIND_HELP_FAMILY = 9;
     */
    HELP_FAMILY = 9,
    /**
     * @generated from protobuf enum value: PRIORITY_KIND_GIVING = 10;
     */
    GIVING = 10,
    /**
     * @generated from protobuf enum value: PRIORITY_KIND_CUSTOM = 11;
     */
    CUSTOM = 11
}
/**
 * @generated from protobuf enum core.v1.MaritalStatus
 */
export enum MaritalStatus {
    /**
     * @generated from protobuf enum value: MARITAL_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: MARITAL_STATUS_SINGLE = 1;
     */
    SINGLE = 1,
    /**
     * @generated from protobuf enum value: MARITAL_STATUS_MARRIED = 2;
     */
    MARRIED = 2,
    /**
     * @generated from protobuf enum value: MARITAL_STATUS_COMMON_LAW = 3;
     */
    COMMON_LAW = 3
}
/**
 * @generated from protobuf enum core.v1.RetirementMethod
 */
export enum RetirementMethod {
    /**
     * treated as SPENDING
     *
     * @generated from protobuf enum value: RETIREMENT_METHOD_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * work the target out from what the household spends
     *
     * @generated from protobuf enum value: RETIREMENT_METHOD_SPENDING = 1;
     */
    SPENDING = 1,
    /**
     * the user picked a share of income and an age (RetirementGoal)
     *
     * @generated from protobuf enum value: RETIREMENT_METHOD_TARGET = 2;
     */
    TARGET = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class FinancialPriority$Type extends MessageType<FinancialPriority> {
    constructor() {
        super("core.v1.FinancialPriority", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "level", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "next_due_date", kind: "message", T: () => Date },
            { no: 5, name: "required_funding", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "end_date", kind: "message", T: () => Date },
            { no: 8, name: "is_recurring", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "date_schedule", kind: "message", T: () => DateSchedule },
            { no: 10, name: "kind", kind: "enum", T: () => ["core.v1.PriorityKind", PriorityKind, "PRIORITY_KIND_"] },
            { no: 11, name: "funded_this_period", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "beneficiary_uuids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.FinancialPriority
 */
export const FinancialPriority = new FinancialPriority$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HomebuyingPriority$Type extends MessageType<HomebuyingPriority> {
    constructor() {
        super("core.v1.HomebuyingPriority", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "level", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "due_date", kind: "message", T: () => Date },
            { no: 5, name: "house_price", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "address", kind: "message", T: () => Address },
            { no: 7, name: "down_payment", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.HomebuyingPriority
 */
export const HomebuyingPriority = new HomebuyingPriority$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Dependent$Type extends MessageType<Dependent> {
    constructor() {
        super("core.v1.Dependent", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "given_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "family_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "dob", kind: "message", T: () => Date }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Dependent
 */
export const Dependent = new Dependent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Family$Type extends MessageType<Family> {
    constructor() {
        super("core.v1.Family", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "family_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "education_priority_level", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "retirement_priority_level", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "financial_priorities", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => FinancialPriority },
            { no: 7, name: "dependents", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Dependent },
            { no: 8, name: "mortgages", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Mortgage },
            { no: 9, name: "loans", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Loan },
            { no: 10, name: "persons", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Person },
            { no: 11, name: "expenses", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Expense },
            { no: 12, name: "homebuying_priorities", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => HomebuyingPriority },
            { no: 13, name: "properties", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Property },
            { no: 14, name: "province", kind: "enum", T: () => ["core.v1.Province", Province, "PROVINCE_"] },
            { no: 15, name: "marital_status", kind: "enum", T: () => ["core.v1.MaritalStatus", MaritalStatus, "MARITAL_STATUS_"] },
            { no: 16, name: "retirement_method", kind: "enum", T: () => ["core.v1.RetirementMethod", RetirementMethod, "RETIREMENT_METHOD_"] },
            { no: 17, name: "facts_as_of", kind: "message", T: () => Date },
            { no: 18, name: "field_sources", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ValueSource } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Family
 */
export const Family = new Family$Type();
